import { Modal, ModalHeader, ModalBody} from "../Modal";

interface Props {
  modalOpen: boolean
  setModalOpen: Function
  t: Function
  type: string
  selfScore: number
  responsesScore: number
  gap: number
}

import ScoreTable from "../ScoreTable";
import {FeedbackQuestionInterface} from "../../interfaces/common";

export const FeedbackInfoModal = (
  { t, modalOpen, setModalOpen, type, selfScore, responsesScore, gap }: Props
) => {
  const createQuestion = () => {
    const question: FeedbackQuestionInterface = {
      average: responsesScore,
      selfScore: selfScore,
      gap: gap,
      responses: [],
      question: ""
    }
    return question
  }

  return (
    <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
      <ModalHeader onClose={() => setModalOpen(false)}>
        <div className="z-title1">{t("understanding-your-scores")}</div>
      </ModalHeader>
      <div style={{maxHeight: 'calc(100dvh - 90px)', overflowY: 'auto'}}>
        <ModalBody>
          <ScoreTable question={createQuestion()} type={type} size="small"/>
          <div className="mt-4 text-white">{t("self-assessment")}:</div>
          <div className="text-base text-gray-300">{t("average-of-your-answers")}</div>
          <div className="mt-4 text-white">{t("feedback-score")}:</div>
          <div className="text-base text-gray-300">{t("average-feedback-colleagues")}</div>
          <div className="mt-4 text-white">{t("perception-gap")}:</div>
          <div className="text-base text-gray-300">
            <p>{t("difference-between-above")}.</p>
            <p className="mt-4">{t("striped-areas-represents")}</p>
          </div>

          <div className="mt-4 text-white">{t("how-we-calculate-score")}:</div>
          <div className="text-base text-gray-300">
            <p>{t("how-we-calculate-text")}</p>
          </div>

          <div className="mt-4 text-white">{t("answer-score-correlation")}:</div>
          <div className="mt-1 text-base text-gray-400 flex justify-between">
            <p>{t('strongly-agree')}</p>
            <p>5.0</p>
          </div>
          <hr className="mt-1 border-indigo-700" />

          <div className="text-base text-gray-400 flex justify-between">
            <p>{t('agree')}</p>
            <p>4.0</p>
          </div>
          <hr className="mt-1 border-indigo-700" />

          <div className="text-base text-gray-400 flex justify-between">
            <p>{t('neutral')}</p>
            <p>3.0</p>
          </div>
          <hr className="mt-1 border-indigo-700" />

          <div className="text-base text-gray-400 flex justify-between">
            <p>{t('disagree')}</p>
            <p>2.0</p>
          </div>
          <hr className="mt-1 border-indigo-700" />

          <div className="text-base text-gray-400 flex justify-between">
            <p>{t('strongly-disagree')}</p>
            <p>1.0</p>
          </div>
          <hr className="mt-1 border-indigo-700" />

          <div className="text-base text-gray-400 flex justify-between">
            <p>{t('not-answered')}</p>
            <p>{t('not-included')}</p>
          </div>
          <hr className="mt-1 border-indigo-700" />
        </ModalBody>
      </div>
    </Modal>
  )
}